export default function initImageZoom() {
  Alpine.data('imageZoom', () => ({
    zoomIn(event: MouseEvent) {
      // @ts-ignore
      this.$el.classList.add('zooming');
      const image = this.$el.querySelector('img') as HTMLElement;

      const scale = 3; // Zoom level

      // @ts-ignore
      const rect = this.$el.getBoundingClientRect();

      const x = ((event.clientX - rect.left) / rect.width) * 100;
      const y = ((event.clientY - rect.top) / rect.height) * 100;

      image.style.transformOrigin = `${x}% ${y}%`;
      image.style.transform = `scale(${scale})`;
    },
    zoomOut() {
      // @ts-ignore
      this.$el.classList.remove('zooming');
      const image = this.$el.querySelector('img') as HTMLElement;
      image.style.removeProperty('transformOrigin');
      image.style.removeProperty('transform');
    },
  }));
}
